import { render, staticRenderFns } from "./FairWall.vue?vue&type=template&id=4f972a6c&scoped=true"
import script from "./FairWall.vue?vue&type=script&lang=js"
export * from "./FairWall.vue?vue&type=script&lang=js"
import style0 from "./FairWall.vue?vue&type=style&index=0&id=4f972a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f972a6c",
  null
  
)

export default component.exports